import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    NgModule,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Validator } from 'breeze-client';
import { SharedComponentsModule } from '../../../../../../shared-components.module';
import { IsImperial } from '../../../../../takeoff/core/functions';
import { EstimatePlansTakeOffsStatesV2 } from '../../feat-estimate-plans-take-offs-v2/domain';
import {
    EstimateMeasurementStoresService,
    EstimateMeasurementVM,
    EstimateMeasurementViewSettings,
    TakeOffSupportedUnit,
} from '../feat-estimate-measurements-v2/domain';
import { EstimateMeasurementCalculatorService } from '../feat-estimate-measurements-v2/estimate-measurement-calculator.service';
import { EstimateMeasurementItemActionsModule } from '../ui-estimate-measurement-item-actions/estimate-measurement-item-actions.component';

@Component({
    selector: 'app-estimate-measurement',
    templateUrl: './estimate-measurement.component.html',
    styleUrls: ['./estimate-measurement.component.scss'],
    standalone: false,
})
export class EstimateMeasurementComponent implements OnChanges, OnInit, AfterViewInit {
    // @ts-ignore TS2564
    @Input() hasPlans: boolean;
    // @ts-ignore TS2564
    @Input() states: EstimatePlansTakeOffsStatesV2;
    // @ts-ignore TS2564
    @Input() estimateMeasurement: EstimateMeasurementVM;
    // @ts-ignore TS2564
    @Input() supportedUnits: TakeOffSupportedUnit[];
    // @ts-ignore TS2564
    @Input() viewSettings: EstimateMeasurementViewSettings;
    @Input() parentOrder?: number;

    @Output() updateMeasurementChanges = new EventEmitter<EstimateMeasurementVM>();
    @Output() takeOffsChanges = new EventEmitter<EstimateMeasurementVM>();
    @Output() calculateMeasurementChanges = new EventEmitter<EstimateMeasurementVM>();
    @Output() toggleMeasurementChanges = new EventEmitter<EstimateMeasurementVM>();
    @Output() deleteMeasurementChanges = new EventEmitter<EstimateMeasurementVM>();
    @Output() toggleMeasurementDragging = new EventEmitter<boolean>();

    // @ts-ignore TS2564
    public measurementForm: UntypedFormGroup;

    // @ts-ignore TS2564
    public displayedquantity: number;
    // @ts-ignore TS2564
    public isImperial: boolean;

    public isInvalidMeasurement = false;

    // @ts-ignore TS2564
    public order: string;

    // @ts-ignore TS2564
    private expression: string;
    // @ts-ignore TS2564
    @ViewChild('measurementDescription') private elDescription: ElementRef<HTMLElement>;

    constructor(
        private readonly formBuilder: UntypedFormBuilder,
        private readonly estimateMeasurementCalculatorService: EstimateMeasurementCalculatorService,
        public readonly estimateMeasurementStoresService: EstimateMeasurementStoresService
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.states?.currentValue) {
            this.updateMeasurementStates();
        }
    }

    ngOnInit(): void {
        this.initMeasurementForm();

        // @ts-ignore TS2322
        this.displayedquantity = this.estimateMeasurement.quantity;
        // @ts-ignore TS2345
        this.isImperial = IsImperial(this.estimateMeasurement.uom);
        // @ts-ignore TS2322
        this.expression = this.estimateMeasurement.expression;
        this.validateMeasurement();
        this.order = this.parentOrder ? `${this.parentOrder}.${this.estimateMeasurement.order}` : this.estimateMeasurement.order.toString();
    }

    private initMeasurementForm() {
        this.measurementForm = this.formBuilder.group({
            description: [
                {
                    value: this.estimateMeasurement.description,
                    disabled: !this.states.canChangeMeasurements || this.states.isEstimateReadonly,
                },
                { validators: [Validators.required, Validators.maxLength(200)], updateOn: 'blur' },
            ],
            quantity: [
                {
                    value: this.estimateMeasurement.quantity,
                    disabled: !this.states.canChangeMeasurements || this.states.isEstimateReadonly,
                },
                { validators: [Validator.required()] },
            ],
            uom: [
                {
                    value: this.estimateMeasurement.uom,
                    disabled:
                        this.estimateMeasurement.id_PlanMeasurement || !this.states.canChangeMeasurements || this.states.isEstimateReadonly,
                },
            ],
        });

        // @ts-ignore TS2532
        this.measurementForm.controls.description.valueChanges.subscribe(() => this.onSubmitMeasurement());

        // @ts-ignore TS2532
        this.measurementForm.controls.quantity.valueChanges.subscribe((quantity) => {
            this.expression = quantity.toString();
            this.onSubmitMeasurement();
        });

        // @ts-ignore TS2532
        this.measurementForm.controls.uom.valueChanges.subscribe((uom) => {
            this.isImperial = IsImperial(uom);
            this.onSubmitMeasurement();
        });
    }

    ngAfterViewInit(): void {
        if (!this.estimateMeasurement.id) {
            setTimeout(() => {
                this.elDescription.nativeElement.focus();
            }, 0);
        }
    }

    private updateMeasurementStates() {
        if (!this.measurementForm) {
            return;
        }

        if (!this.states.canChangeMeasurements || this.states.isEstimateReadonly) {
            // @ts-ignore TS2532
            if (this.measurementForm.controls['description'].enable) {
                // @ts-ignore TS2532
                this.measurementForm.controls['description'].disable({ emitEvent: false });
            }

            // @ts-ignore TS2532
            if (this.measurementForm.controls['quantity'].enable) {
                // @ts-ignore TS2532
                this.measurementForm.controls['quantity'].disable({ emitEvent: false });
            }

            // @ts-ignore TS2532
            if (this.measurementForm.controls['uom'].enable) {
                // @ts-ignore TS2532
                this.measurementForm.controls['uom'].disable({ emitEvent: false });
            }
        } else if (this.states.canChangeMeasurements && !this.states.isEstimateReadonly) {
            // @ts-ignore TS2532
            if (this.measurementForm.controls['description'].disabled) {
                // @ts-ignore TS2532
                this.measurementForm.controls['description'].enable({ emitEvent: false });
            }

            // @ts-ignore TS2532
            if (this.measurementForm.controls['quantity'].disabled) {
                // @ts-ignore TS2532
                this.measurementForm.controls['quantity'].enable({ emitEvent: false });
            }

            // @ts-ignore TS2532
            if (this.measurementForm.controls['uom'].disabled && !this.estimateMeasurement.id_PlanMeasurement) {
                // @ts-ignore TS2532
                this.measurementForm.controls['uom'].enable({ emitEvent: false });
            }
        }
    }

    public onquantityChanged(value: string) {
        let quantity = parseFloat(value);
        if (isNaN(quantity)) {
            quantity = 0;
        }

        const newquantity = Math.round(quantity * 1000) / 1000;
        // @ts-ignore TS2532
        this.measurementForm.controls.quantity.setValue(newquantity);
    }

    public onTakeOffs() {
        this.takeOffsChanges.emit({
            ...this.estimateMeasurement,
            isSelected: true,
            isMeasurementShown: !!this.estimateMeasurement.id_PlanMeasurement,
            isInTakeOff: true,
        });
    }

    public onCalculate() {
        this.calculateMeasurementChanges.emit({ ...this.estimateMeasurement, isSelected: true });
    }

    public toggleMeasurement(isShown: boolean) {
        this.toggleMeasurementChanges.emit({
            ...this.estimateMeasurement,
            isMeasurementShown: isShown,
            isSelected: true,
            isInTakeOff: this.viewSettings.isOverLayer,
        });
    }

    public onDeleteMeasurement() {
        this.deleteMeasurementChanges.emit({
            ...this.estimateMeasurement,
            isDeleted: true,
            newOrder: -1,
            isMeasurementShown: false,
        });
    }

    private onSubmitMeasurement() {
        this.validateMeasurement();

        if (this.isInvalidMeasurement) {
            return;
        }

        this.updateMeasurementChanges.emit({
            ...this.estimateMeasurement,
            // @ts-ignore TS2532
            description: this.measurementForm.controls.description.value,
            // @ts-ignore TS2532
            quantity: this.measurementForm.controls.quantity.value,
            // @ts-ignore TS2532
            uom: this.measurementForm.controls.uom.value,
            expression: this.expression,
            isSelected: true,
            isInTakeOff: this.viewSettings.isOverLayer,
        });
    }

    private validateMeasurement() {
        // @ts-ignore TS2532
        this.isInvalidMeasurement = this.measurementForm.controls.description.invalid || this.measurementForm.controls.quantity.invalid;
    }

    public toggleDrag(isEnabled: boolean) {
        this.toggleMeasurementDragging.emit(isEnabled);
    }
}

@NgModule({
    declarations: [EstimateMeasurementComponent],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, DragDropModule, SharedComponentsModule, EstimateMeasurementItemActionsModule],
    exports: [EstimateMeasurementComponent],
})
export class EstimateMeasurementModule {}
